import { Box, Paper, Stack, Typography } from '@mui/material';
import { DrawerDetail } from '@common/ui/DrawerDetail/DrawerDetail';
import { DateTime } from '@utils';
import { isValidElement, ReactNode } from 'react';
import { AccessFlowAppModelV2CreationUser } from '@api';

export default function CreateAndEditDetails({
  createdDate,
  createdBy,
  editedDate,
  editedBy,
  variant = 'default',
}: {
  createdDate?: number;
  createdBy?: AccessFlowAppModelV2CreationUser;
  editedDate?: number;
  editedBy?: AccessFlowAppModelV2CreationUser;
  withPaper?: boolean;
  variant?: 'default' | 'small';
}) {
  const hasCreatedBy = createdBy && createdBy.first_name && createdBy.last_name;
  const hasEditedBy = editedBy && editedBy.first_name && editedBy.last_name;

  if (variant === 'small') {
    return (
      <Box>
        {createdDate && (
          <MiniDrawerDetails label="Created at" value={DateTime.fromUnix(Number(createdDate)).readable} />
        )}
        {hasCreatedBy && (
          <MiniDrawerDetails
            label="Created by"
            value={<NameWithEmail name={`${createdBy.first_name} ${createdBy.last_name}`} email={createdBy.email} />}
          />
        )}
        {editedDate && <MiniDrawerDetails label="Edited at" value={DateTime.fromUnix(Number(editedDate)).readable} />}
        {hasEditedBy && (
          <MiniDrawerDetails
            label="Edited by"
            value={<NameWithEmail name={`${editedBy.first_name} ${editedBy.last_name}`} email={editedBy.email} />}
          />
        )}
      </Box>
    );
  }

  return (
    <Paper>
      {createdDate && <DrawerDetail label="Created at" value={DateTime.fromUnix(Number(createdDate)).readable} />}
      {hasCreatedBy && (
        <DrawerDetail
          label="Created by"
          value={<NameWithEmail name={`${createdBy.first_name} ${createdBy.last_name}`} email={createdBy.email} />}
        />
      )}
      {editedDate && <DrawerDetail label="Edited at" value={DateTime.fromUnix(Number(editedDate)).readable} />}
      {hasEditedBy && (
        <DrawerDetail
          label="Edited by"
          value={<NameWithEmail name={`${editedBy.first_name} ${editedBy.last_name}`} email={editedBy.email} />}
        />
      )}
    </Paper>
  );
}

function NameWithEmail({ name, email }: { name: string; email: string }) {
  return (
    <Stack direction="row" spacing={0.5}>
      <Typography variant="caption">{name}</Typography>
      <Typography variant="caption" color="text.muted">
        ({email})
      </Typography>
    </Stack>
  );
}

function MiniDrawerDetails({ label, value }: { label: string; value: ReactNode | string }) {
  return (
    <Box paddingY={0.75} paddingX={1}>
      <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
        <Typography variant={'caption'} color="text.muted">
          {label}:
        </Typography>
        {isValidElement(value) ? value : <Typography variant="caption">{value}</Typography>}
      </Stack>
    </Box>
  );
}
